/**
 @class SignagePlayerView
 @constructor
 @return {Object} instantiated SignagePlayerView
 **/
define(['jquery', 'backbone', 'bootbox'], function ($, Backbone) {

    var SignagePlayerView = Backbone.View.extend({

        /**
         Constructor
         @method initialize
         **/
        initialize: function () {

            /*
            $('#myCarousel').carousel({
                interval: false
            });

            var clickEvent = false;
            $('#myCarousel').on('click', '.nav a', function () {
                clickEvent = true;
                $('.nav li').removeClass('active');
                $(this).parent().addClass('active');
            }).on('slid.bs.carousel', function (e) {
                if (!clickEvent) {
                    var count = $('.nav').children().length - 1;
                    var current = $('.nav li.active');
                    current.removeClass('active').next().addClass('active');
                    var id = parseInt(current.data('slide-to'));
                    if (count == id) {
                        $('.nav li').first().addClass('active');
                    }
                }
                clickEvent = false;
            });
            */
        }
    })

    return SignagePlayerView;

});




// WEBPACK FOOTER //
// ./_views/SignagePlayerView.js